import { render } from "./PriceSummary.vue?vue&type=template&id=588d3b5f&scoped=true&lang=pug"
import script from "./PriceSummary.vue?vue&type=script&lang=ts"
export * from "./PriceSummary.vue?vue&type=script&lang=ts"

import "./PriceSummary.vue?vue&type=style&index=0&id=588d3b5f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-588d3b5f"

export default script